import { useNavigate } from "react-router-dom";

export function LandingFooter() {
    const navigate = useNavigate();
    return (
        <footer className="border-t border-white/10 py-10" data-testid="landing-footer">
            <div className="max-w-7xl mx-auto px-5 md:px-10 flex flex-col sm:flex-row items-center justify-between gap-4">
                <p className="font-mono text-xs text-muted-foreground">© WhiteWater AI 2026 · Veteran Owned and Operated 🇺🇸</p>
                <div className="flex items-center gap-5 text-sm">
                    <button onClick={() => navigate("/privacy")} className="text-muted-foreground hover:text-white transition-colors">Privacy</button>
                    <button onClick={() => navigate("/terms")} className="text-muted-foreground hover:text-white transition-colors">Terms</button>
                    <button onClick={() => navigate("/login")} className="text-muted-foreground hover:text-white transition-colors" data-testid="footer-login">Log In</button>
                    <button onClick={() => navigate("/register")} className="text-volt hover:underline" data-testid="footer-cta">Start Free Trial</button>
                </div>
            </div>
        </footer>
    );
}
